// extracted by mini-css-extract-plugin
module.exports = {"input":"InputItem_input__15v6W","wrap":"InputItem_wrap__1olUm"};